<script setup lang="ts">
import CarePlanOverview from '@/views/apps/nursing/care-plan-details/CarePlanOverview.vue'
import CarePlanGoals from '@/views/apps/nursing/care-plan-details/CarePlanGoals.vue'
import CarePlanInterventions from '@/views/apps/nursing/care-plan-details/CarePlanInterventions.vue'
import CarePlanDocuments from '@/views/apps/nursing/care-plan-details/CarePlanDocuments.vue'

// DAY-37: only for users whose roles allow it (same permission the API checks)
definePage({
  meta: {
    action: 'read',
    subject: 'CarePlans',
  },
})

const { t } = useI18n()
const route = useRoute()

const carePlanId = computed(() => Number(route.params.id))

const tabsData = [
  { icon: 'bx-user', title: 'Overview' },
  { icon: 'bx-target-lock', title: 'Goals' },
  { icon: 'bx-list-check', title: 'Interventions' },
  { icon: 'bx-file', title: 'Documents' },
]

const activeTab = ref(0)

// Handle tab query param for deep linking
const routeQuery = computed(() => route.query.tab as string | undefined)

watch(routeQuery, (newTab) => {
  if (newTab) {
    const tabIndex = tabsData.findIndex(tab => tab.title.toLowerCase() === newTab.toLowerCase())
    if (tabIndex !== -1) {
      activeTab.value = tabIndex
    }
  }
}, { immediate: true })
</script>

<template>
  <div>
    <div class="d-flex align-center gap-x-4 mb-6">
      <VBtn
        variant="tonal"
        color="secondary"
        :to="{ name: 'apps-nursing-care-plans' }"
      >
        <VIcon icon="bx-arrow-back" class="me-2" />
        {{ t('Back to Care Plans') }}
      </VBtn>
      <h4 class="text-h4">
        {{ t('Care Plan Details') }} #{{ carePlanId }}
      </h4>
    </div>

    <VCard>
      <VRow>
        <VCol
          cols="12"
          md="3"
          :class="$vuetify.display.smAndDown ? 'border-b' : 'border-e'"
        >
          <VCardText>
            <VTabs
              v-model="activeTab"
              direction="vertical"
              class="v-tabs-pill"
            >
              <h3>{{ t('Care Plan Sections') }}</h3>
              <VTab
                v-for="(tabItem, index) in tabsData"
                :key="index"
              >
                <VIcon :size="18" :icon="tabItem.icon" class="me-1" />
                <span>{{ t(tabItem.title) }}</span>
              </VTab>
            </VTabs>
          </VCardText>
        </VCol>

        <VCol cols="12" md="9">
          <VCardText class="px-2 px-md-4">
            <VWindow
              v-model="activeTab"
              class="disable-tab-transition"
              :touch="false"
            >
              <VWindowItem>
                <CarePlanOverview :care-plan-id="carePlanId" />
              </VWindowItem>

              <VWindowItem>
                <CarePlanGoals :care-plan-id="carePlanId" />
              </VWindowItem>

              <VWindowItem>
                <CarePlanInterventions :care-plan-id="carePlanId" />
              </VWindowItem>

              <VWindowItem>
                <CarePlanDocuments :care-plan-id="carePlanId" />
              </VWindowItem>
            </VWindow>
          </VCardText>
        </VCol>
      </VRow>
    </VCard>
  </div>
</template>

